import React from 'react';
import { Mail, Phone } from 'lucide-react';
import { footerData, contactData } from '../../data/mock';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <h4 className="font-semibold text-white text-lg">{footerData.brand}</h4>
            <p className="text-slate-400 text-sm leading-relaxed">
              {footerData.tagline}
            </p>
          </div>

          {/* Links */}
          <div className="space-y-4">
            <h4 className="font-semibold text-white">Navegação</h4>
            <nav className="flex flex-col gap-2">
              <a href="#solucao" className="text-slate-400 hover:text-amber-400 transition-colors text-sm">
                Como Funciona
              </a>
              <a href="#planos" className="text-slate-400 hover:text-amber-400 transition-colors text-sm">
                Planos
              </a>
              <a href="#faq" className="text-slate-400 hover:text-amber-400 transition-colors text-sm">
                Dúvidas Frequentes
              </a>
            </nav>
          </div>

          {/* Contact Info - Display only, no CTA */}
          <div className="space-y-4">
            <h4 className="font-semibold text-white">Informações</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-slate-400 text-sm">
                <Mail className="w-4 h-4" />
                <span>{contactData.email}</span>
              </div>
              <div className="flex items-center gap-3 text-slate-400 text-sm">
                <Phone className="w-4 h-4" />
                <span>{contactData.whatsapp.display}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-slate-800">
          <p className="text-center text-slate-500 text-sm">
            {footerData.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
